import React, { useState } from 'react';
import { Box, Stack, Typography, Button, Paper, Popper, TextField, MenuItem } from '@mui/material';
import { AddEntityPlusIcon, BucketIcon, DownArrowIcon } from './CustomSvgIcons';
import CloseIcon from '@mui/icons-material/Close';
import { metricPlanClasses, miscClasses, newTaskValuesConstants } from './constants';
import { generalFunctionClasses, popupClasses, metricPlanCardClasses } from './constants';
import { availableCategories } from './constants';

export const BucketDetail = props => {
  const { taskValues = [], currDarkThemeClass, values, task, handleSetTask } = props;
  const [popperAnchorEl, setPopperAnchorEl] = useState(null);
  const [popperOpen, setPopperOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');

  const allTaskValues = task?.task_values || [];

  const bucketCategories = {};

  if (Array.isArray(taskValues)) {
    taskValues.forEach(item => {
      if (item?.datatype?.startsWith('bucket_category')) {
        const categoryMatch = item.datatype.match(/bucket_category_(\d+)_(\w+)/);
        if (categoryMatch) {
          const categoryNum = categoryMatch[1];
          const type = categoryMatch[2];

          if (!bucketCategories[categoryNum]) {
            bucketCategories[categoryNum] = { id: null, name: null, count: null, categoryNum: categoryNum };
          }
          if (type === 'id') bucketCategories[categoryNum].id = item.value;
          if (type === 'name') bucketCategories[categoryNum].name = item.value || item.key;
          if (type === 'count') bucketCategories[categoryNum].count = item.value || 0;
        }
      }
    });
  }

  const buckets = Object.values(bucketCategories).filter(bucket => bucket.name);

  const handleRemoveBucketCategory = bucket => {
    if (!Array.isArray(allTaskValues)) {
      console.error('task_values is not an array');
      return;
    }

    const categoryNum = bucket.categoryNum;
    const updatedTaskValues = allTaskValues.filter(item => {
      if (item?.datatype?.startsWith('bucket_category')) {
        const categoryMatch = item.datatype.match(/bucket_category_(\d+)_(\w+)/);
        if (categoryMatch && categoryMatch[1] === categoryNum) {
          return false;
        }
      }
      return true;
    });

    handleSetTask(task, 'task_values_remove', updatedTaskValues);
  };

  const handleAddClick = e => {
    setPopperAnchorEl(e.currentTarget);
    setPopperOpen(true);
    setSelectedCategory('');
  };

  const handleCancel = () => {
    setPopperOpen(false);
    setPopperAnchorEl(null);
    setSelectedCategory('');
  };

  const handleCategoryChange = e => {
    setSelectedCategory(e.target.value);
  };

  const handleAddCategory = () => {
    if (!selectedCategory) return;

    const category = availableCategories.find(cat => cat.id === selectedCategory);
    if (!category) return;

    const newTaskValues = newTaskValuesConstants(category);

    handleSetTask(task, 'task_values', newTaskValues);
    handleCancel();
  };

  const bucketcategoriesMenuProps = {
    select: true,
    fullWidth: true,
    label: 'Select Category',
    value: selectedCategory,
    onChange: handleCategoryChange,
    className: `${popupClasses?.strainEntry?.textField} ${currDarkThemeClass}`,
    SelectProps: {
      IconComponent: DownArrowIcon,
      MenuProps: {
        className: currDarkThemeClass,
      },
    },
  };

  const selectedCategoryIds = buckets.map(bucket => (bucket.id !== null && bucket.id !== undefined ? String(bucket.id) : null)).filter(Boolean);

  const availableCategoriesFiltered = availableCategories.filter(category => !selectedCategoryIds.includes(String(category.id)));

  return (
    <>
      <Box>
        <Typography sx={{ width: '100%', textAlign: 'start', color: 'white' }}>Bucket Categories</Typography>
        <Stack direction="row" spacing={8} sx={{ flexWrap: 'wrap', justifyContent: 'flex-start', gap: 4 }}>
          {buckets.map((bucket, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: 200,
                p: 2,
                borderRadius: '8px',
              }}
            >
              <Box sx={{ position: 'relative' }}>
                <BucketIcon />
              </Box>
              <Typography variant="body2" sx={{ mt: 1, textAlign: 'center', fontWeight: 'bold', color: 'white' }}>
                {bucket.name}
              </Typography>
              <Button variant="outlined" color="error" size="small" sx={{ mt: 1 }} onClick={() => handleRemoveBucketCategory(bucket)}>
                Remove
              </Button>
            </Box>
          ))}

          {buckets.length < 3 && (
            <Box
              onClick={handleAddClick}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: 150,
                height: 150,
                borderRadius: '8px',
                cursor: 'pointer',
                p: 2,
              }}
            >
              <AddEntityPlusIcon style={{ width: '32px', height: '32px' }} />
              <Typography style={{ color: 'white', marginTop: '8px', textAlign: 'center' }}>Add Bucket Category</Typography>
            </Box>
          )}
        </Stack>
      </Box>

      <Popper open={popperOpen} anchorEl={popperAnchorEl} placement="bottom" sx={{ zIndex: 1300, backgroundColor: 'black' }}>
        <Paper sx={{ p: 2, width: 300, maxWidth: '100%' }} className={`${metricPlanCardClasses?.paperWrapper} ${currDarkThemeClass}`}>
          <Box
            className={`${generalFunctionClasses?.popper?.closeIconBox} ${currDarkThemeClass}`}
            sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon className={`${popupClasses?.entityDetail?.closeIcon} ${currDarkThemeClass}`} onClick={handleCancel} />
          </Box>

          <Typography className={`${generalFunctionClasses?.popper?.titleTypo} ${currDarkThemeClass}`} sx={{ textAlign: 'center' }}>
            Add Bucket Category
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField {...bucketcategoriesMenuProps}>
              {availableCategories.map(category => {
                // ID to string
                const categoryIdStr = String(category.id);
                const isDisabled = selectedCategoryIds.includes(categoryIdStr);

                return (
                  <MenuItem
                    key={category.id}
                    value={category.id}
                    disabled={isDisabled}
                    className={`${metricPlanClasses?.menuItem} ${currDarkThemeClass}`}
                    focusVisibleClassName={miscClasses?.menuItemFocusDark}  >
                    {category.name} {isDisabled ? '(Already Exists)' : ''}
                  </MenuItem>
                );
              })}
              {availableCategoriesFiltered.length === 0 && <MenuItem disabled>All categories have been added</MenuItem>}
            </TextField>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Button variant="contained" color="primary" onClick={handleAddCategory} disabled={!selectedCategory}>
                Add
              </Button>
            </Box>
          </Box>
        </Paper>
      </Popper>
    </>
  );
};
